import http from './HttpService';
import LocalStorageService from './local-storage-service';

import urls from '../constants/Urls';
import { WEB_PLATFORM_VERSION } from 'shared/infra/constants/platform.const';

const isAuthenticated = () => {
  return LocalStorageService.isAuthenticated();
};

const login = (email, password) => {
  const baseUrl = LocalStorageService.getBaseUrl();
  const loginDto = {
    username: email,
    password: password,
  };
  return http.post(`${baseUrl}${urls.LOGIN}`, loginDto, {
    headers: {
      'PLATFORM-VERSION': `${WEB_PLATFORM_VERSION}`,
    },
  });
};

const getUUIDfromSession = () => {
  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  );
};

const setDeviceId = () => {
  // Get the current device Id in localStorage.
  const currentDeviceId = LocalStorageService.getDeviceId();
  if (currentDeviceId && currentDeviceId !== 'null') {
    // If it exists, mean it is already set, so just return it.
    return currentDeviceId;
  }
  // If no token Id in LocalStorage, create one and save it in LocalStorage.
  const newDeviceId = getUUIDfromSession();
  LocalStorageService.setDeviceId(newDeviceId);

  return newDeviceId;
};

const s4 = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

/**
 * When `true`, every unauthenticated entry point leaves the SPA for the
 * unified login instead of mounting the legacy in-app Aliados `<LoginPage>`.
 * Flip to `false` to fully restore the legacy login: the old code paths are
 * kept intact behind this flag precisely so the rollback is a one-line change.
 * @type {boolean}
 */
const UNIFIED_LOGIN_ENABLED = true;

/**
 * Sends the browser to the unified login page (RA-6824).
 *
 * Uses a full-page navigation (not a router push) so the SPA unloads before
 * its router can mount the legacy login, avoiding any flash of the old screen.
 * @returns {void}
 */
const goToUnifiedLogin = () => {
  window.location.href = process.env.REACT_APP_UNIFIED_LOGIN_URL;
};

const PORTAL_PARTNERS_HANDOFF_PARAM = 'from';
const PORTAL_PARTNERS_HANDOFF_VALUE = 'portalPartners';

const isPortalPartnersHandoff = search =>
  new URLSearchParams(search).get(PORTAL_PARTNERS_HANDOFF_PARAM) ===
  PORTAL_PARTNERS_HANDOFF_VALUE;

/**
 * Whether the app must render the legacy in-app `<LoginPage>` instead of
 * redirecting to the unified login. True when the unified-login migration is
 * rolled back (`UNIFIED_LOGIN_ENABLED` off) OR the current URL is a Portal
 * Partners / unified assisted-login handoff (`?from=portalPartners`), whose
 * shared-cookie read happens inside `<LoginPage>`.
 * @param {string} search - the raw `location.search` query string.
 * @returns {boolean}
 */
const mustUseLegacyLogin = search =>
  !UNIFIED_LOGIN_ENABLED || isPortalPartnersHandoff(search);

export default {
  getUUIDfromSession,
  goToUnifiedLogin,
  isAuthenticated,
  login,
  mustUseLegacyLogin,
  setDeviceId,
  UNIFIED_LOGIN_ENABLED,
};
